// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l8-1";
export var messageSideRight = "_l8-2";
export var subscribeToBackInStockBubbleContainer = "_l8-0";